import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vivek-bansod',
  templateUrl: './vivek-bansod.component.html',
  styleUrls: ['./vivek-bansod.component.scss']
})
export class VivekBansodComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
